// extracted by mini-css-extract-plugin
export var productCell = "g33JdKWkNkQVWH66Qniv";
export var productCellSkeleton = "ZcMVi3QVmkHuO1q4FZjH";
export var productLogo = "FhqiTDItRW1wZXEtY3eH";
export var productName = "YY0lOUwsPH75FTeMYRk7";
export var protocolContainer = "ukVNEkAuNcPXza168LmQ";
export var protocolLogo = "PI_r_wbLpjqLE8prukzR";
export var skeleton = "BmwJznZgCzNhbH43_m3R";
export var skeletonItem = "wxgoW4qfa9dYAcE0OSG1";
export var totalSkeleton = "SviEFAGgJcF9hUnoShXn";